import React from 'react';
import { Link } from 'react-router-dom';


export default function Project3() {
  return (
    <div className="project1-text">
      <div className="mx-auto pt-5 px-6">

        <h1 className="text-4xl font-bold pb-3">
          Card Deck
        </h1>

        <p className="md:text-xl max-w-3xl mx-auto pb-3">
          Native SwiftUI card game built to explore application state,
          game logic, user interaction, and collaborative iOS development.
        </p>

        <p className="project-tech">
          Swift • SwiftUI • Xcode • Git
        </p>


        <h2 className="text-2xl font-bold pt-8 pb-3">
          Project Overview
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          Card Deck is an iOS game in which the player competes against the
          computer by dealing cards and comparing their values. The higher card
          scores a point, and the player with the highest score wins the game.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          What I Built
        </h2>

        <div className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          <ul className="list-disc pl-8 space-y-3">
            <li>
              Native user interface built with SwiftUI.
            </li>

            <li>
              Game-state management for player and computer scores.
            </li>

            <li>
              Randomized card dealing and comparison logic.
            </li>

            <li>
              User interactions for dealing cards and progressing through
              gameplay.
            </li>

            <li>
              Reusable interface components for cards, controls, and score
              presentation.
            </li>

            <li>
              Git and GitHub workflows for source control and collaborative
              development.
            </li>
          </ul>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Development Experience
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          This project provided early hands-on experience building native iOS
          interfaces with SwiftUI, managing application state, implementing
          interactive logic, and collaborating through a shared source-control
          workflow.
        </p>


        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://github.com/swanmac/Card-Deck"
              target="_blank"
              rel="noopener noreferrer"
            >
              View GitHub Repository
            </a>
          </h3>

          <h3 className="pt-5">
            <Link to="/projects">
              Back to Projects
            </Link>
          </h3>
        </div>

      </div>

    
    </div>
  );
}